<div class="plan-comparison-card">

  <div class="plan-comparison-header">
    {{ comparisonTableTitle }}
  </div>

  <div
    class="plan-comparison-grid"
    [style.grid-template-columns]="gridTemplateColumns"
  >

    <!-- Plan name row -->
    <div class="plan-comparison-cell plan-comparison-cell--label"></div>
    <div
      *ngFor="let plan of comparisonTableHeaders; trackBy: trackByPlanName"
      class="plan-comparison-cell plan-comparison-cell--plan-header plan-comparison-cell--plan-name-row"
    >
      <div class="plan-comparison-plan-name">{{ plan.name }}</div>
    </div>

    <!-- Plan price row -->
    <div class="plan-comparison-cell plan-comparison-cell--label"></div>
    <div
      *ngFor="let plan of comparisonTableHeaders; trackBy: trackByPlanName"
      class="plan-comparison-cell plan-comparison-cell--plan-header"
    >
      <div class="plan-comparison-plan-price">{{ plan.price }}</div>
    </div>

    <!-- Plan price note row -->
    <div class="plan-comparison-cell plan-comparison-cell--label"></div>
    <div
      *ngFor="let plan of comparisonTableHeaders; trackBy: trackByPlanName"
      class="plan-comparison-cell plan-comparison-cell--plan-header plan-comparison-cell--plan-note"
    >
      <div class="plan-comparison-plan-price-note">{{ plan.priceNote }}</div>
    </div>

    <!-- Feature rows -->
    <ng-container
      *ngFor="let feature of comparisonTableFeatures; let i = index; trackBy: trackByFeatureLabel"
    >
      <div
        class="plan-comparison-cell plan-comparison-cell--label"
        [class.plan-comparison-row--alt]="i % 2 === 1"
      >
        {{ feature.label }}
      </div>

      <div
        *ngFor="let value of feature.values"
        class="plan-comparison-cell plan-comparison-cell--value"
        [class.plan-comparison-row--alt]="i % 2 === 1"
      >
        <span *ngIf="value === true" class="plan-comparison-check" aria-label="Included">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 10.5L8.5 14L15 6.5"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span *ngIf="value === false" class="plan-comparison-dash" aria-label="Not included">
          &mdash;
        </span>
        <span *ngIf="value !== true && value !== false" class="plan-comparison-text">
          {{ value }}
        </span>
      </div>
    </ng-container>

  </div>
</div>

<div class="plan-comparison-learn-more-row" [style.grid-template-columns]="gridTemplateColumns">
  <div></div>
  <div
    *ngFor="let plan of comparisonTableHeaders; trackBy: trackByPlanName"
    class="plan-comparison-learn-more-cell"
  >
    <a
      *ngIf="showLearnMore(plan)"
      [routerLink]="plan.route"
      class="plan-comparison-learn-more lh-1 fw-bold rounded-pill"
    >
      Learn more<span class="visually-hidden"> about {{ plan.name }}</span>
    </a>
  </div>
</div>
